import { render } from "./GetExternalLogin.vue?vue&type=template&id=53c54c98"
import script from "./GetExternalLogin.vue?vue&type=script&lang=js"
export * from "./GetExternalLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/windowOverlay/GetExternalLogin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53c54c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53c54c98', __exports__)) {
    api.reload('53c54c98', __exports__)
  }
  
  module.hot.accept("./GetExternalLogin.vue?vue&type=template&id=53c54c98", () => {
    api.rerender('53c54c98', render)
  })

}


export default __exports__